// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"9":"f8a85816","155":"a7a5387b","489":"4c6310ea","820":"3701b85c","954":"a7a59f90","961":"4f5048cc"}[chunkId] + ".css";
};